<div class="card card-custom">
	<div class="card-header">
		<div class="card-title">Datos de Receptor</div>
	</div>
	<div class="card-content">
		<div class="card-body" [formGroup]="receptorBheFormGroup" #localFormRef="ngForm">
			<div class="row">
				<div class="col-12 form-group">
					<div class="row">
						<div class="col-1 label-control">Fecha</div>
						<div class="col-4">
							<input type="text" class="form-control" formControlName="fechaEmision" [minDate]="todayString" ngxDaterangepickerMd [locale]="locale" autocomplete="off" (change)="detectChangeDate($event)" [singleDatePicker]="true" [autoApply]="true" />
						</div>
						<div class="col-4 offset-sm-1">
							<div class="custom-control custom-switch">
								<input type="checkbox" class="custom-control-input" id="customSwitchRetencion" formControlName="retencionEmisor" (change)="changeRetencionEmisor($event)" />
								<label class="custom-control-label label-control" for="customSwitchRetencion">Retención de Emisor</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 form-group">
					<div class="row">
						<div class="col-1 label-control">Rut</div>
						<div class="col-4">
							<input type="text" class="form-control" formControlName="rutReceptor" (change)="onSubmit()" />
							<!-- *ngIf="(submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('rutString').invalid) || (emisorSuperGroup.controls.base.get('rutString').invalid && emisorSuperGroup.controls.base.get('rutString').touched)" -->
							<div *ngIf="localFormRef.touched && receptorBheFormGroup.get('rutReceptor').invalid" class="text-danger">
								<div *ngIf="receptorBheFormGroup.get('rutReceptor').errors?.required">Campo requerido</div>
								<div *ngIf="receptorBheFormGroup.get('rutReceptor').errors.VerificacionRutValidator" class="text-danger">Rut Invalido</div>
							</div>
						</div>

						<div class="col-1 label-control text-right">Nombre</div>
						<div class="col-6">
							<input type="text" class="form-control" formControlName="nombreReceptor" (change)="onSubmit()" />
							<div *ngIf="localFormRef.touched && (receptorBheFormGroup.get('nombreReceptor').invalid || receptorBheFormGroup.get('nombreReceptor').dirty)" class="text-danger">
								<div *ngIf="receptorBheFormGroup.get('nombreReceptor').errors?.required">Campo requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 form-group">
					<div class="row">
						<div class="col-1 label-control">Domicilio</div>
						<div class="col-4">
							<input type="text" class="form-control" formControlName="domicilio" (click)="onSubmit()" />
							<div *ngIf="localFormRef.touched && (receptorBheFormGroup.get('domicilio').invalid || receptorBheFormGroup.get('domicilio').dirty)" class="text-danger">
								<div *ngIf="receptorBheFormGroup.get('domicilio').errors?.required">Campo requerido</div>
							</div>
						</div>
						<div class="col-1 label-control text-right">Región</div>
						<div class="col-3">
							<ng-select [items]="regionesSource" [clearable]="false" [multiple]="false" formControlName="region" bindLabel="nombre" [placeholder]="'Seleccione una región'" (change)="onRegionChange($event)"></ng-select>
							<div *ngIf="localFormRef.touched && (receptorBheFormGroup.get('region').invalid || receptorBheFormGroup.get('region').dirty)" class="text-danger">
								<div *ngIf="receptorBheFormGroup.get('region').errors?.required">Campo requerido</div>
							</div>
						</div>
						<div class="col-1 label-control text-right">Comuna</div>
						<div class="col-2">
							<ng-select [items]="comunasSource" [clearable]="false" [multiple]="false" formControlName="comuna" bindLabel="nombre" (change)="onComunaChange($event)" [placeholder]="'Comunas de la región seleccionada'"></ng-select>
							<div *ngIf="localFormRef.touched && (receptorBheFormGroup.get('comuna').invalid || receptorBheFormGroup.get('comuna').dirty)" class="text-danger">
								<div *ngIf="receptorBheFormGroup.get('comuna').errors?.required">Campo requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
